<div class="modal-header text-center">
  <h4 class="modal-title f-w w-100 text-uppercase">Switch to this tab?</h4>
</div>
<div class="modal-body p-20">
  <div class="_card white-bg">
    <div class="row">
      <div class="col-md-12 mb-3">
        <h2 class="text-center">You have an active session in another tab. 
          Switching to this tab will redirect you to the dashboard.</h2>
      </div>
    </div>
  </div>
  <div class="footer">
    <button class="offset-md-3 col-md-6 btn btn-primary" (click)="handleAction()">
        Set this tab as active
    </button>
  </div>
</div>
